import type { ActionTypes } from '../actions/suite.actions'
import { Suite } from '../actionTypes'
import type { GroupRuleInfo } from '@src/endpoints/services/intentMgr.service'

export interface Suite extends GroupRuleInfo {}

export const defaultState = {
  list: [] as Suite[],
  reportPending: null as string,
  totalCount: 0,
  failedCount: 0,
  passedCount: 0
}

type SuiteState = typeof defaultState

export function reducer(state = defaultState, action: ActionTypes): SuiteState {
  switch (action.type) {
    case Suite.GET_SUITES: {
      return {
        ...state,
        list: action.payload.suites,
        totalCount: action.payload.total,
        failedCount: action.payload.failing,
        passedCount: action.payload.passing
      }
    }
    case Suite.GET_REPORT:
    case Suite.REPORT_GENERATED: {
      return {
        ...state,
        reportPending: action.payload.pendingReport
      }
    }
    default: {
      return state
    }
  }
}
